import React, { useEffect, useState } from 'react';
import { FileText, X, Save, Loader2 } from 'lucide-react';
import { callWFAPI } from '../utils/helper';
interface InternalNotesButtonProps {
  rentalId: string;
  initialNotes?: string;
  onNotesSaved?: (notes: string) => void;
}
export function InternalNotesButton({
  rentalId,
  initialNotes = '',
  onNotesSaved
}: InternalNotesButtonProps) {
  const [showModal, setShowModal] = useState(false);
  const [notes, setNotes] = useState(initialNotes);
  const [isSaving, setIsSaving] = useState(false);
  const [hasNotes, setHasNotes] = useState(!!initialNotes);
  useEffect(() => {
    setNotes(initialNotes);
    setHasNotes(!!initialNotes);
  }, [initialNotes]);
  const handleSave = async () => {
    setIsSaving(true);
    try {
      const rentalUpdateData = {
        appname: 'tkd-score',
        reportname: 'Gen_3_Scoring_Rental_Report',
        id: rentalId,
        params: JSON.stringify({
          Internal_Notes: notes
        })
      };
      await callWFAPI(0, 'zohoCreator', rentalUpdateData);
      setHasNotes(!!notes);
      setShowModal(false);
      if (onNotesSaved) {
        onNotesSaved(notes);
      }
    } catch (error) {
      console.error('Error saving internal notes:', error);
      alert('Failed to save notes. Please try again.');
    } finally {
      setIsSaving(false);
    }
  };
  return <>
      <button onClick={e => {
      e.stopPropagation();
      setShowModal(true);
    }} className={`p-1.5 rounded transition-colors ${hasNotes ? 'bg-amber-100 text-amber-700 hover:bg-amber-200' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'}`} title="Internal Notes" data-id="element-857">
        <FileText size={16} data-id="element-858" />
      </button>

      {showModal && <div className="fixed inset-0 bg-black bg-opacity-50 z-[70] flex items-center justify-center p-4" onClick={e => {
      e.stopPropagation();
      setShowModal(false);
    }} data-id="element-859">
          <div className="bg-white rounded-lg shadow-2xl w-full max-w-lg" onClick={e => e.stopPropagation()} data-id="element-860">
            <div className="bg-slate-50 border-b border-slate-200 p-4 flex items-center justify-between rounded-t-lg" data-id="element-861">
              <div className="flex items-center gap-2" data-id="element-862">
                <FileText size={20} className="text-amber-600" data-id="element-863" />
                <h3 className="text-lg font-bold text-slate-800" data-id="element-864">
                  Internal Notes
                </h3>
              </div>
              <button onClick={e => {
            e.stopPropagation();
            setShowModal(false);
          }} disabled={isSaving} className="p-2 hover:bg-slate-200 rounded-lg transition-colors disabled:opacity-50" data-id="element-865">
                <X size={20} className="text-slate-600" data-id="element-866" />
              </button>
            </div>

            <div className="p-6" data-id="element-867">
              <div className="mb-4" data-id="element-868">
                <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-4" data-id="element-869">
                  <p className="text-xs text-amber-800" data-id="element-870">
                    <strong data-id="element-871">Admin Only:</strong> These notes are for internal
                    use only and are not visible to customers. They will follow
                    this rental through all stages (dispatch, onsite prep,
                    etc.).
                  </p>
                </div>

                <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-872">
                  Notes
                </label>
                <textarea value={notes} onChange={e => setNotes(e.target.value)} rows={8} disabled={isSaving} className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500 resize-none disabled:bg-slate-50 disabled:text-slate-500" placeholder="Add internal notes about this rental..." data-id="element-873" />
              </div>

              <div className="flex gap-3" data-id="element-874">
                <button onClick={e => {
              e.stopPropagation();
              setShowModal(false);
            }} disabled={isSaving} className="flex-1 px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-875">
                  Cancel
                </button>
                <button onClick={e => {
              e.stopPropagation();
              handleSave();
            }} disabled={isSaving} className="flex-1 px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors font-medium disabled:bg-slate-300 disabled:cursor-not-allowed flex items-center justify-center gap-2" data-id="element-876">
                  {isSaving ? <>
                      <Loader2 size={18} className="animate-spin" data-id="element-877" />
                      Saving...
                    </> : <>
                      <Save size={18} data-id="element-878" />
                      Save Notes
                    </>}
                </button>
              </div>
            </div>
          </div>
        </div>}
    </>;
}